// Utilitaires pour Firebase Auth dans l'application
import { initializeApp, getApp, getApps } from "firebase/app";
import { 
  getAuth, 
  browserLocalPersistence, 
  setPersistence
} from "firebase/auth";
import { onAuthStateChanged } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Variables partagées
let firebaseApp: any;
// Initialiser la référence d'authentification
export let auth: any;
// Indicateur d'initialisation complète
let isFirebaseFullyInitialized = false;

// Fonction pour logger l'état du stockage (utile pour le debugging)
export const logStorageState = () => {
  // Réduire la verbosité en production
  if (process.env.NODE_ENV === 'production') return;
  
  console.group("ÉTAT DU STOCKAGE");
  
  // LocalStorage
  const localStorageKeys = Object.keys(localStorage || {});
  console.log("ÉTAPE 9.1: État du localStorage:", {
    length: localStorageKeys.length,
    keys: localStorageKeys
  });
  
  // SessionStorage
  const sessionStorageKeys = Object.keys(sessionStorage || {});
  console.log("ÉTAPE 9.2: État du sessionStorage:", {
    length: sessionStorageKeys.length,
    keys: sessionStorageKeys,
    pendingRedirect: sessionStorage.getItem('firebase:pendingRedirect') || null,
    authUserCredential: sessionStorage.getItem('firebase:authUser') || null
  });
  
  // Cookies
  console.log("ÉTAPE 9.3: État des cookies:", document.cookie);
  
  console.groupEnd();
};

// Configuration de Firebase - Utiliser les identifiants officiels
export const firebaseConfig = {
  apiKey: "AIzaSyD6AquMrrda1jgXxQEKXAK2GRSWcZpXODA",
  authDomain: "etudown-abd0d.firebaseapp.com", // Toujours utiliser l'authDomain Firebase officiel
  projectId: "etudown-abd0d",
  storageBucket: "etudown-abd0d.appspot.com",
  messagingSenderId: "225449274982",
  appId: "1:225449274982:web:6b682cde6c38c40b8f07a7", // Revenir à l'ancien appId qui fonctionnait
  measurementId: "G-TQ79CL7HJQ", // Utiliser l'ancien measurementId correspondant
};

// Gestion globale des erreurs en développement
if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  window.addEventListener("error", function(e) {
    console.log("Erreur globale:", e.message);
    console.log("Stack:", e.error?.stack);
  });
}

/**
 * Initialise Firebase si ce n'est pas déjà fait
 * Utilise un pattern singleton amélioré pour éviter les réinitialisations inutiles
 */
export function initializeFirebase() {
  // Si Firebase est déjà complètement initialisé, retourner sans rien faire
  if (isFirebaseFullyInitialized) {
    return;
  }
  
  try {
    // Vérifier si Firebase est déjà initialisé
    if (!getApps().length) {
      console.log(" Initialisation Firebase (première fois)");
      
      // Initialiser l'application Firebase
      firebaseApp = initializeApp(firebaseConfig);
      
      // Obtenir l'instance d'authentification
      auth = getAuth(firebaseApp);
      
      // Sur Vercel, configuration spéciale pour les redirections
      if (typeof window !== 'undefined' && window.location.hostname.includes('vercel.app')) {
        try {
          // @ts-ignore - Cette propriété existe mais n'est pas typée
          auth.settings = auth.settings || {};
          // @ts-ignore - Configuration spéciale pour les domaines croisés
          auth.settings.appVerificationDisabledForTesting = true;
        } catch (e) {
          console.error("Erreur lors de la configuration pour Vercel:", e);
        }
      }
      
      // Configurer la persistance pour maintenir la session
      setPersistence(auth, browserLocalPersistence)
        .then(() => {
          console.log(" Persistance locale configurée");
          isFirebaseFullyInitialized = true;
        })
        .catch((err: Error) => {
          console.error(" Erreur de configuration de persistance:", err);
        });
        
      // Initialiser Analytics en production uniquement
      if (process.env.NODE_ENV === 'production') {
        try {
          getAnalytics(firebaseApp);
        } catch (error) {
          console.warn("Analytics non disponible:", error);
        }
      }
    } else {
      // Si l'app existe déjà mais n'est pas complètement initialisée
      if (!isFirebaseFullyInitialized) {
        console.log(" Récupération de l'instance Firebase existante");
        firebaseApp = getApp();
        auth = getAuth(firebaseApp);
        isFirebaseFullyInitialized = true;
      }
    }
    
    // Surveiller les changements d'état d'authentification (une seule fois)
    if (!window.__firebaseAuthObserverSet) {
      onAuthStateChanged(auth, (user: any) => {
        if (user) {
          console.log(`État d'authentification changé: Connecté`);
          console.log(`Utilisateur: ${user.email}`);
          console.log(`UID: ${user.uid.substring(0, 5)}...`);
        } else {
          console.log(`État d'authentification changé: Déconnecté`);
        }
      });
      
      // Marquer l'observateur comme configuré
      window.__firebaseAuthObserverSet = true;
    }

  } catch (error) {
    console.error(" ERREUR d'initialisation Firebase", error);
  }
}

// Flag global pour TypeScript
declare global {
  interface Window {
    __firebaseAuthObserverSet?: boolean;
  }
}

// Initialiser Firebase automatiquement au chargement du module
initializeFirebase();